<!-- 服务切换 -->
<template>
  <div class="phone-select" :class="{ show: showPopup }">
    <van-dialog
      v-model="showPopup"
      :className="className"
      :lazy-render="true"
      title="门店电话"
      :lock-scroll="false"
      show-cancel-button
      :show-confirm-button="false"
      :close-on-click-overlay="true"
      @close="closePopup"
      v-backFn="{ show: openPopup, closeFn: 'closePopup' }"
    >
      <div class="phone-wrap">
        <div class="phone-list" v-for="(item, index) in phoneList" :key="index">
          <a class="phone-list-item" :href="`tel:${item}`">{{ item }}</a>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import clientEnv from '@/utils/clientEnv'

export default {
  name: 'phoneSelect',
  props: {
    phoneList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      showPopup: false,
      selectedIndex: 0,
      className: clientEnv.isVivoApp
        ? clientEnv.isPAD
          ? 'dialog-class-app dialog-class-pad'
          : 'dialog-class-app'
        : 'dialog-class-wap'
    }
  },
  computed: {
    lazyRender() {
      return !clientEnv.isVivoApp
    }
  },
  methods: {
    // 阻止页面滑动
    preventPageScroll() {
      if (this.isPrevent || document.body.classList.contains('isPrevent')) {
        return
      }

      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      this.marginTop = document.body.style.marginTop
      this.height = document.body.style.height
      this.overflow = document.body.style.overflow
      Object.assign(document.body.style, {
        marginTop: -this.scrollTop + 'px',
        height: window.innerHeight + this.scrollTop + 'px',
        overflow: 'hidden'
      })
      document.body.classList.add('isPrevent')
      this.isPrevent = true
    },
    // 恢复页面滑动
    restorePageScroll() {
      if (!this.isPrevent) {
        return
      }

      Object.assign(document.body.style, {
        marginTop: this.marginTop,
        height: this.height,
        overflow: this.overflow
      })
      document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop
      document.body.classList.remove('isPrevent')
      this.isPrevent = false
    },
    openPopup() {
      this.preventPageScroll()
      this.showPopup = true
    },
    closePopup() {
      this.restorePageScroll()
      this.showPopup = false
    }
  }
}
</script>

<style lang="scss" scoped>
.phone-select {
  ::v-deep .van-overlay {
    transition: all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
  }

  ::v-deep .van-dialog.dialog-class-app {
    display: block !important;
    transition:
      transform 0.25s cubic-bezier(0.2, 0.7, 0.6, 1),
      bottom 0.3s cubic-bezier(0.19, 0, 0.33, 1) 0.25s;
    transform: translateX(-50%);
    bottom: 28px;

    &.dialog-class-pad {
      top: auto;
      border-radius: 30px;
      bottom: 50%;
      transform: translateX(-50%) translateY(50%);
    }
  }

  &:not(.show) {
    ::v-deep .van-dialog.dialog-class-app {
      transition: all 0.3s cubic-bezier(0.5, 0.2, 0.5, 1);
      transform: translateX(-50%) translateY(calc(100% + 40px));
      bottom: 40px;

      &.dialog-class-pad {
        transform: translateX(-50%) translateY(calc(100% + (50vh + 12px)));
        bottom: calc(50vh + 12px);
      }
    }
  }

  ::v-deep .van-dialog {
    &.dialog-class-wap {
      top: 50%;
      border-radius: 18px;
      padding: 27px 28px 27px;
      width: 328px;
      box-sizing: border-box;

      .van-dialog__header {
        line-height: 20px;
        padding-top: 0;
        @include font-weight-two(16, 600);
      }

      .phone-wrap {
        padding-top: 24px;
      }

      .phone-list {
        .phone-list-item {
          border-bottom: 1px solid #f2f2f2;
          height: 53px;
          box-sizing: border-box;
          line-height: 53px;
          @include font-weight-two(15, 400);

          .vivo-dark-mode & {
            border-color: rgba(255, 255, 255, 0.15);
          }
        }
      }

      .van-hairline--top {
        transition: none;

        &::after {
          border-top-width: 0px !important;
        }
      }

      .van-dialog__content {
        width: 100%;
        margin-bottom: 24px;
      }

      .van-dialog__message {
        padding: 0 0;
      }

      .van-button {
        width: 168px;
        height: 46px;
        line-height: 46px;
        display: flex;
        justify-content: center;
        @include font-weight-two(16, 500);

        .van-button__content {
          width: 168px;
          height: 46px;
          border-radius: 82px;
          background-color: #f5f7fa;
        }
      }

      .van-dialog__cancel {
        width: 168px;
        height: 46px;
        color: #333333;

        &::before {
          display: none;
        }

        .van-button__content {
          background-color: #f5f7fa;
        }
      }

      .van-hairline--top {
        &::after {
          border: 0;
        }
      }

      .van-hairline--left {
        &::after {
          border: 0;
        }
      }
    }

    &.dialog-class-app {
      border-radius: 30px;
      padding: 40px 28px 12px;
      width: 304px;
      box-sizing: border-box;

      .van-dialog__header {
        line-height: 20px;
        padding-top: 0;
        @include font-weight-two(16, 600);
      }

      .phone-wrap {
        padding-top: 24px;
      }

      .phone-list {
        .phone-list-item {
          border-bottom: 1px solid #f2f2f2;
          height: 53px;
          box-sizing: border-box;
          line-height: 53px;
          @include font-weight-two(15, 400);

          .vivo-dark-mode & {
            border-color: rgba(255, 255, 255, 0.15);
          }
        }
      }

      .van-hairline--top {
        align-items: center;
        transition: none;

        &::after {
          border-top-width: 0px !important;
        }
      }

      .van-dialog__content {
        width: 100%;
        margin-bottom: 20px;
      }

      .van-dialog__message {
        padding: 0 0;
      }

      .van-button {
        width: 168px;
        height: 54px;
        line-height: 54px;
        display: flex;
        justify-content: center;
        @include font-weight-two(16, 500);

        .van-button__content {
          width: 168px;
          height: 54px;
          // border-radius: 82px;
          // background-color: #f5f7fa;
        }
      }

      .van-dialog__cancel {
        width: 168px;
        height: 54px;
        color: #415fff;

        &::before {
          display: none;
        }

        .van-button__content {
          // background-color: #f5f7fa;
        }
      }

      .van-hairline--top {
        &::after {
          border: 0;
        }
      }

      .van-hairline--left {
        &::after {
          border: 0;
        }
      }
    }

    &.dialog-class-pad {
      bottom: auto;
      border-radius: 30px;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
    }
  }
}
</style>
